import {
  createNaturalDivisionRemainderTask,
  randInt,
  remainderDivisionExplanation,
} from "./sharedNaturalDivision";

function pickData() {
  const b = randInt(3, 6);
  const quotient = randInt(12, 19);
  const remainder = randInt(1, b - 1);
  const product = quotient * b;
  const a = product + remainder;
  return { a, b, quotient, remainder, product };
}

const mod = createNaturalDivisionRemainderTask({
  type: "NaturalDivRemainderLargerTask",
  pickData,
  explain: remainderDivisionExplanation,
});

export const generateTask = mod.generateTask;
export const renderTask = mod.renderTask;
export const renderInput = mod.renderInput;
export const checkAnswer = mod.checkAnswer;
export const renderAnswer = mod.renderAnswer;
export const renderUserAnswer = mod.renderUserAnswer;
export const renderExplanation = mod.renderExplanation;
